import { useState } from 'react';
import Slider from '@/common/SlickSlider';
import Box from '@mui/material/Box';
import useStore, { selectFavoriteCountryId, selectCountryTheme } from '@/hooks/client/useStore';
import { useMediaQuery } from '@mui/material';
import CustomPaging from '@/common/CustomPaging';

const css = {
  dots: {
    listStyle: 'none',
    gap: 0,
    justifyContent: 'center',
    mt: 2,
    p: 0,
    m: 0,
    display: 'flex',
  },
  main: (isLandscape) => ({
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    pt: isLandscape ? 2 : 4,
    pb: isLandscape ? 0 : 4,
  }),
  wrapper: (isLandscape) => ({
    width: isLandscape ? 220 : '90%', // Limita el ancho del slider
    maxWidth: 300,
  }),
  sliderWrapper: () => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    px: 1,
  }),
  img: {
    width: '100%',
    borderRadius: 8,
    objectFit: 'contain',
  },
};

const FindBatchCodeSlider = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const countryCode = useStore(selectFavoriteCountryId);
  const countryTheme = useStore(selectCountryTheme);
  const isLandscape = useMediaQuery('(orientation:landscape)');

  const images = [
    // TODOO: dinamic
    `/images/${countryCode}/pack1.png`,
    `/images/${countryCode}/pack2.png`,
    `/images/${countryCode}/pack3.png`,
  ];

  const settings = {
    dots: !isLandscape,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    afterChange: (index) => setActiveIndex(index),
    appendDots: (dots) => (
      <Box component="ul" sx={css.dots}>
        {dots}
      </Box>
    ),
  };

  return (
    <Box sx={css.main(isLandscape)}>
      <Box sx={css.wrapper(isLandscape)}>
        <Slider
          {...settings}
          customPaging={(i) => (
            <CustomPaging i={i} activeIndex={activeIndex} color={countryTheme.accentColor2} />
          )}
        >
          {images.map((src, index) => (
            <Box key={src} sx={css.sliderWrapper}>
              <img src={src} alt={`slide-${index}`} style={css.img} />
            </Box>
          ))}
        </Slider>
      </Box>
    </Box>
  );
};

export default FindBatchCodeSlider;
